import { ButtonProps, useMediaQuery } from '@cmg/design-system';
import { ReactElement, useMemo } from 'react';

import {
  ContextMenuActions,
  ContextMenuActionsProps,
} from '../../context-menu-actions/ContextMenuActions';

export type UseIndicationSectionActionsProps = {
  actions: ReactElement<ButtonProps>[];
  contextMenuActions?: ContextMenuActionsProps[];
  smallScreenActions?: ReactElement<ButtonProps>[];
  smallScreenContextMenuActions?: ContextMenuActionsProps[];
  mediaQueryParams?: Parameters<typeof useMediaQuery>;
};

export function useIndicationSectionActions({
  actions,
  contextMenuActions,
  smallScreenActions,
  smallScreenContextMenuActions,
  mediaQueryParams = ['(max-width:520px)'],
}: UseIndicationSectionActionsProps) {
  const matchesSmallScreen = useMediaQuery(...mediaQueryParams);
  return useMemo(() => {
    if (matchesSmallScreen) {
      const smallScreenSectionActions: ReactElement<ButtonProps>[] = [];

      if (smallScreenActions) {
        smallScreenSectionActions.push(...smallScreenActions);
      }

      if (smallScreenContextMenuActions) {
        smallScreenSectionActions.push(
          <ContextMenuActions
            key="context-menu"
            contextMenuActions={smallScreenContextMenuActions}
          />
        );
      }
      return smallScreenSectionActions;
    }
    const sectionActions = [...actions];
    if (contextMenuActions) {
      sectionActions.push(
        <ContextMenuActions key="context-menu" contextMenuActions={contextMenuActions} />
      );
    }
    return sectionActions;
  }, [
    matchesSmallScreen,
    actions,
    contextMenuActions,
    smallScreenActions,
    smallScreenContextMenuActions,
  ]);
}
